import { useContext } from 'react'
import memberShipWidgetIcon from 'src/assets/MembershipWidgetIcon.png'
import { BusinessPaywallContext } from '../paywall/PaywallProvider'
import {
  MyMembershipMembersContainer,
  MyMembershipWidgetContainer,
  MyMembershipWidgetDetailStat,
  MyMembershipWidgetDetailsContainer,
  MyMembershipWidgetDetailsItemHeading,
  MyMembershipWidgetExtraItemButton,
  MyMembershipWidgetHeading,
  MyMembershipWidgetHeadingContainer,
  MyMembershipWidgetItemContainer,
  MyMembershipWidgetItemImage,
  MyMembershipWidgetItemImageContainer,
  MyMembershipWidgetItemImgAndItemContainer,
  MyMembershipWidgetItemsParent,
  WidgetItemProgressColor,
} from './MyMembershipWidgetStyles'
import membershipWidgetIcon from 'src/assets/MembershipWidgetIcon.png'

export default function MyMembershipWidget() {
  const { togglePaywall } = useContext(BusinessPaywallContext)

  const serverData = {
    moreItemsAvailable: true,
    data: [
      {
        heading: 'Onboarded Members',
        currentCount: 50,
        maxCount: 65,
        secondaryText: 'Members Onboarded',
        image: 'IMG-11bea895a06049bcb7242ebdc4209846',
        enabled: true,
      },
      {
        heading: 'Webinars And Group Sessions',
        currentCount: 1,
        maxCount: 3,
        secondaryText: 'Webinars Conducted',
        image: 'IMG-11bea895a06049bcb7242ebdc4209846',
        enabled: true,
      },
      {
        heading: 'Sessions with Therapists',
        currentCount: 6,
        maxCount: 15,
        secondaryText: 'Consultations Used',
        image: 'IMG-11bea895a06049bcb7242ebdc4209846',
        enabled: true,
      },
      {
        heading: 'Consultation with Psychiatrists',
        currentCount: 7,
        maxCount: 12,
        secondaryText: 'Consultations used',
        image: 'IMG-11bea895a06049bcb7242ebdc4209846',
        enabled: true,
      },
    ],
  }

  return (
    <MyMembershipWidgetContainer>
      <MyMembershipWidgetHeadingContainer>
        <MyMembershipWidgetHeading main>This Month</MyMembershipWidgetHeading>
        <MyMembershipWidgetHeading>Usage Overview</MyMembershipWidgetHeading>
      </MyMembershipWidgetHeadingContainer>

      <MyMembershipWidgetItemsParent>
        {serverData?.data?.map((itemData, index) => {
          if (itemData?.enabled) {
            return <MemberDetailsItemComponent key={index} data={itemData} />
          } else {
            return <DisabledMemberDetailsItemComponent key={index} data={itemData} />
          }
        })}

        {/* {serverData?.moreItemsAvailable && (
          <MyMembershipWidgetExtraItem>
            <span>Want More?</span>
            <MyMembershipWidgetExtraItemButton onClick={togglePaywall}>
              Upgrade Now
            </MyMembershipWidgetExtraItemButton>
          </MyMembershipWidgetExtraItem>
        )} */}
      </MyMembershipWidgetItemsParent>
    </MyMembershipWidgetContainer>
  )
}

function MemberDetailsItemComponent({ data }) {
  return (
    <MyMembershipWidgetItemImgAndItemContainer>
      <MyMembershipWidgetItemContainer>
        <WidgetItemProgressColor
          programRequestedWidth={(data?.currentCount / data?.maxCount) * 100}
        />
        <MyMembershipWidgetDetailsContainer>
          <MyMembershipWidgetDetailsItemHeading>
            {data?.heading}
          </MyMembershipWidgetDetailsItemHeading>
          <MyMembershipMembersContainer>
            <MyMembershipWidgetDetailStat big>
              {data?.currentCount}/{data?.maxCount}
            </MyMembershipWidgetDetailStat>
            <MyMembershipWidgetDetailStat>{data?.secondaryText}</MyMembershipWidgetDetailStat>
          </MyMembershipMembersContainer>
        </MyMembershipWidgetDetailsContainer>
      </MyMembershipWidgetItemContainer>
      <MyMembershipWidgetItemImageContainer>
        <MyMembershipWidgetItemImage src={memberShipWidgetIcon} />
      </MyMembershipWidgetItemImageContainer>
    </MyMembershipWidgetItemImgAndItemContainer>
  )
}

function DisabledMemberDetailsItemComponent({ data }) {
  const { togglePaywall } = useContext(BusinessPaywallContext)

  return (
    <MyMembershipWidgetItemImgAndItemContainer>
      <MyMembershipWidgetItemContainer>
        <MyMembershipWidgetDetailsContainer coverFullHeight>
          <MyMembershipWidgetDetailsItemHeading>
            {data?.heading}
          </MyMembershipWidgetDetailsItemHeading>
          <MyMembershipMembersContainer>
            <MyMembershipWidgetDetailStat>
              You don&apos;t have this. Why wait when you can get it now!
            </MyMembershipWidgetDetailStat>
          </MyMembershipMembersContainer>
          <MyMembershipWidgetExtraItemButton onClick={togglePaywall}>
            Get now
          </MyMembershipWidgetExtraItemButton>
        </MyMembershipWidgetDetailsContainer>
      </MyMembershipWidgetItemContainer>
      <MyMembershipWidgetItemImageContainer>
        <MyMembershipWidgetItemImage src={membershipWidgetIcon} />
      </MyMembershipWidgetItemImageContainer>
    </MyMembershipWidgetItemImgAndItemContainer>
  )
}
